
export function getFunctionsBase() {
    var urlbase;
    if (process.env.NODE_ENV === "production") {
        urlbase = "https://us-central1-pumi-app.cloudfunctions.net"
    } else {
        urlbase = "http://localhost:5000/pumi-app/us-central1";
    }
    return urlbase
}

export const ADMIN_EMAIL = "szundi@gmail.com";

export function isAdmin(user) {
    return !!(user && user.email && user.email.toLowerCase() === ADMIN_EMAIL);
}
